import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Home from "./components/pages/Home";

function App() {
  return (
    <Router>
      {/* React Routerのルート設定 */}
      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/gallery" element={<GalleryInfo />} /> */}
      </Routes>
    </Router>
  );
}

export default App;
